module.exports = __webpack_public_path__ + "img/massAttacks.ff2a0ed.svg";